import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-lock-circle-icon',
  templateUrl: './code-lock-circle.component.html'
})
export class CodeLockCircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
